(function () {
  if (window.__kalvePricePanel) return;
  window.__kalvePricePanel = true;

  // Appstle's Widget Design Builder appends a preset look to the widget's custom
  // CSS, between appstle-builder markers. Its selectors are keyed on the widget
  // id with !important, so it outranks every rule in appstle-widget.css and
  // replaces our design. Strip that section wherever Appstle injects it, and
  // keep the rest of the custom CSS (the loyalty-table and tooltip hides).
  var BUILDER_CSS = /\/\*\s*appstle-builder:start[\s\S]*?appstle-builder:end\s*\*\//g;

  function stripBuilderCss(style) {
    var css = style.textContent;
    if (css.indexOf('appstle-builder:start') === -1) return;
    style.textContent = css.replace(BUILDER_CSS, '');
  }

  Array.prototype.forEach.call(document.querySelectorAll('style'), stripBuilderCss);
  new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      if (m.target.nodeName === 'STYLE') stripBuilderCss(m.target);
      Array.prototype.forEach.call(m.addedNodes, function (n) {
        if (n.nodeName === 'STYLE') stripBuilderCss(n);
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });

  var APPSTLE_WIDGET_SELECTOR = '[id^="appstle_subscription_widget"], .appstle_sub_widget, .appstle_subscription_wrapper';
  var APPSTLE_CLASS = 'has-appstle-subscription';
  // .x-block-price is the PDP title price, price-sticky-* the sticky bar, and
  // .add_to_cart_button renders price.liquid inline too.
  var PRICE_BLOCK_SELECTOR = '.x-block-price, [id^="price-sticky-"], .add_to_cart_button, .x-card-price';
  // Same list, narrowed to blocks we tagged. Derived so the two cannot drift.
  var TAGGED_PRICE_BLOCK_SELECTOR = PRICE_BLOCK_SELECTOR.split(',')
    .map(function (sel) {
      return sel.trim() + '.' + APPSTLE_CLASS;
    })
    .join(', ');

  function formatMoney(cents, format) {
    cents = parseInt(cents, 10);
    if (isNaN(cents)) return '';
    format = format || moneyFormat(null);
    if (!format) return '';

    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var match = format.match(placeholderRegex);
    var key = match ? match[1] : 'amount';
    var precision = key.indexOf('no_decimals') !== -1 ? 0 : 2;
    var comma = key.indexOf('comma_separator') !== -1;
    var thousands = comma ? '.' : ',';
    var decimal = comma ? ',' : '.';
    var number = (cents / 100).toFixed(precision);
    var parts = number.split('.');
    var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    var frac = parts[1] ? decimal + parts[1] : '';
    return format.replace(placeholderRegex, dollars + frac);
  }

  // Shopify.money_format is undefined on this storefront, so the literal
  // fallback this used to end in printed the shop's default symbol on every
  // market: a euro PDP showed "$12.20" under its own "€12,20". The theme
  // renders the market's format into data-money-format on the PDP price block
  // and the sticky bar - the add to cart button carries no such attribute, so
  // borrow it from whichever block on the page does.
  var pageFormat = '';
  function moneyFormat(block) {
    var own = block && block.getAttribute('data-money-format');
    if (own) return own;
    if (!pageFormat) {
      var source = document.querySelector('[data-money-format]');
      if (source) pageFormat = source.getAttribute('data-money-format') || '';
    }
    // Empty means unknown, and every caller treats an empty amount as "leave
    // the Liquid-rendered price alone" - right currency beats a guess.
    return pageFormat || (window.Shopify && Shopify.money_format) || '';
  }

  function findScope(node) {
    return (
      node.closest('[id^="shopify-section-"]') ||
      node.closest('.shopify-section') ||
      node.closest('.main-product') ||
      node.closest('.quick-view') ||
      node.parentElement
    );
  }

  function scopeHasAppstle(scope) {
    return !!(scope && scope.querySelector(APPSTLE_WIDGET_SELECTOR));
  }

  // Recommendation and frequently-bought cards sit in a different
  // shopify-section from the widget, so scopeHasAppstle() never sees it. They
  // do carry Appstle's injected prices and badges, so detect those directly.
  function blockHasAppstleJunk(block) {
    return !!(
      block &&
      block.querySelector(
        '[class*="appstle"], [class*="Appstle"], [class*="saveBadge"], [class*="save_badge"], [class*="save-badge"]'
      )
    );
  }

  function tagScopes() {
    // Fall back to the widget being anywhere in the page. findScope() can miss
    // it when Appstle mounts outside the block's own section, and a miss
    // silently disables every price fix below.
    var pageHasAppstle = scopeHasAppstle(document);
    document.querySelectorAll(PRICE_BLOCK_SELECTOR).forEach(function (block) {
      block.classList.remove(APPSTLE_CLASS);
      var scope = findScope(block);
      var widgetInScope = scopeHasAppstle(scope) || pageHasAppstle;
      if (!widgetInScope && !blockHasAppstleJunk(block)) return;
      block.classList.add(APPSTLE_CLASS);
      // Only tag forms where the widget genuinely lives. A recommendation card
      // carrying injected prices must not flag every form in its section.
      if (!widgetInScope) return;
      scope.querySelectorAll('form.form').forEach(function (form) {
        form.classList.add(APPSTLE_CLASS);
      });
    });
  }

  function isAppstleJunk(el) {
    if (!el || el.nodeType !== 1) return false;
    if (el.classList.contains('price-compare') || el.classList.contains('price-sale')) return false;
    if (el.tagName === 'P' && el.classList.contains('price')) return false;

    var cls = String(el.className || '');
    if (/appstle/i.test(cls)) return true;
    if (/saveBadge|save_badge|SaveBadge|savedBadge|saved_amount|save-badge/i.test(cls)) return true;

    var text = String(el.textContent || '').replace(/\s+/g, ' ').trim();
    if (/^SAVE\s*\d/i.test(text)) return true;
    if ((el.tagName === 'S' || el.tagName === 'DEL') && !el.classList.contains('price-compare')) return true;
    return false;
  }

  // Subscription prices emitted by snippets/selling-plan-prices.liquid:
  // { "<variant id>": { "<selling plan id>": <price in cents> } }
  var planPriceCache = null;
  function planPrices() {
    if (planPriceCache) return planPriceCache;
    var el = document.querySelector('[data-kalve-plan-prices]');
    if (!el) return null;
    try {
      // Only cached once parsed, so a section re-render that injects this later
      // is still picked up.
      planPriceCache = JSON.parse(el.textContent);
    } catch (e) {
      planPriceCache = null;
    }
    return planPriceCache;
  }

  // Price the customer will actually be charged, when a subscription plan is
  // selected. Keyed off input[name="selling_plan"], which Shopify's cart API
  // requires, so it does not depend on Appstle's markup.
  function selectedPlanCents(block) {
    var map = planPrices();
    if (!map) return NaN;
    var scope = findScope(block) || document;

    var planId = '';
    var checked = scope.querySelector('input[name="selling_plan"]:checked');
    if (checked) planId = String(checked.value || '').trim();
    if (!planId) {
      var dropdown = scope.querySelector('select[name="selling_plan"]');
      if (dropdown) planId = String(dropdown.value || '').trim();
    }
    if (!planId) return NaN;

    var idInput = scope.querySelector('input[name="id"]');
    var byVariant = idInput ? map[String(idInput.value || '').trim()] : null;
    if (!byVariant) return NaN;

    var cents = byVariant[planId];
    return typeof cents === 'number' ? cents : NaN;
  }

  // Fallback when the selling-plan JSON lookup misses - a missing snippet, or a
  // variant/plan id that does not line up. Reads the price off the selected
  // purchase-option row, where Appstle has already rendered it correctly.
  function selectedRowMoney(block) {
    var scope = findScope(block) || document;
    var checked = scope.querySelector('input[name="selling_plan"]:checked');
    if (!checked || !String(checked.value || '').trim()) return '';

    var node = checked.closest('.kalve-sub-card') || checked.parentElement;
    for (var i = 0; node && i < 4; i++) {
      // Never climb past this row into one holding the other purchase option,
      // or the first amount found would be the one-time price.
      if (node.querySelectorAll('input[name="selling_plan"]').length > 1) break;
      var text = String(node.textContent || '').replace(/\s+/g, ' ');
      var amounts = text.match(/[\$€£]\s?\d[\d\s.,']*/g);
      // First amount is the current price; the struck original follows it.
      if (amounts && amounts.length) return amounts[0].trim();
      node = node.parentElement;
    }
    return '';
  }

  // The variant's one-time price in cents, read from the hidden div price.liquid
  // renders beside the visible amount.
  function themeCents(panel) {
    var centsEl = panel && panel.querySelector('.target-price');
    if (!centsEl) return NaN;
    return parseInt(String(centsEl.textContent).replace(/[^\d]/g, ''), 10);
  }

  // The add-to-cart button shows a line total, not a unit price: the theme's own
  // updatePrice() writes qty x the one-time price into it on every quantity
  // change. Everything else here - the title price, the sticky bar - stays a
  // unit price, which is what the theme does too.
  function blockQuantity(block) {
    if (!block.classList.contains('add_to_cart_button')) return 1;
    // block is the <button>, so .form resolves its form="" association. The
    // quantity input is bound to the same form without being nested inside it.
    var form = block.form || block.closest('form');
    var input = form && form.elements ? form.elements.quantity : null;
    // Two controls of the same name yield a RadioNodeList, whose value getter
    // only means anything for a radio group and is "" here. Take the first
    // control instead; a lone input has a tagName, the list does not.
    if (input && !input.tagName) input = input[0];
    var qty = input ? parseInt(input.value, 10) : 1;
    return qty > 0 ? qty : 1;
  }

  function themeMoney(panel, block, qty) {
    var cents = themeCents(panel);
    var money = isNaN(cents) ? '' : formatMoney(cents * (qty || 1), moneyFormat(block));
    // Falls through when the format is unknown: scraping the rendered amount
    // below loses the quantity multiple but keeps the market's currency.
    if (money) return money;

    var p = panel.querySelector('p.price');
    if (!p) return '';
    var clone = p.cloneNode(true);
    clone.querySelectorAll('s, del').forEach(function (n) {
      n.remove();
    });
    var texts = String(clone.textContent || '').match(/[\$€£]\s*[\d][\d\s.,']*/g);
    if (texts && texts.length) return texts[texts.length - 1].trim();
    return String(p.textContent || '').trim();
  }

  // compareMoney is optional and only ever passed for the PDP title price: it
  // renders struck through after the amount, the way the Subscribe & Save row
  // shows the one-time price next to the subscription one.
  function flattenParagraph(p, money, compareMoney) {
    if (!p || !money) return;
    // Idempotent on purpose. Rewriting unconditionally mutates the DOM on every
    // pass, which retriggers the MutationObserver that called us - an endless
    // write loop that also races Appstle for the last word on the price.
    var kids = p.children;
    if (
      kids.length === (compareMoney ? 2 : 1) &&
      kids[0].tagName === 'SPAN' &&
      (!compareMoney || kids[1].tagName === 'S') &&
      p.textContent === money + (compareMoney || '')
    ) {
      return;
    }
    p.textContent = '';
    var span = document.createElement('span');
    span.textContent = money;
    span.style.setProperty('text-decoration', 'none', 'important');
    p.appendChild(span);
    if (compareMoney) {
      var compare = document.createElement('s');
      // price-compare exempts it from the two sweeps that drop every other
      // struck price in this block - isAppstleJunk() here and the
      // s:not(.price-compare) rules in appstle-widget.css.
      compare.className = 'price-compare kalve-sub-compare';
      compare.textContent = compareMoney;
      p.appendChild(compare);
    }
    p.style.setProperty('text-decoration', 'none', 'important');
  }

  // Selecting a plan on the product page makes Appstle strike the one-time
  // price through on every card in the page - recommendations and frequently
  // bought together included, since those carry its injected markup too.
  //
  // appstle-widget.css already says .x-card-price p.price must not be struck
  // and it is not enough, for two reasons. Appstle applies the line inline,
  // which outranks a stylesheet; and text-decoration propagates from whichever
  // ancestor carries it, so a descendant setting none cannot lift it - the line
  // has to be cleared on the element that draws it.
  //
  // <s> and <del> are skipped: a genuine compare-at price should stay struck,
  // and being the UA stylesheet's own marking it re-strikes itself regardless
  // of what we clear on its ancestors.
  function unstrikeCard(block) {
    var nodes = [block];
    block.querySelectorAll('*').forEach(function (el) {
      nodes.push(el);
    });
    nodes.forEach(function (el) {
      if (el.tagName === 'S' || el.tagName === 'DEL') return;
      if (el.classList.contains('price-compare')) return;
      if (el.closest('s, del')) return;
      var decoration = '';
      try {
        decoration = window.getComputedStyle(el).textDecorationLine || '';
      } catch (e) {}
      if (decoration.indexOf('line-through') === -1) return;
      el.style.setProperty('text-decoration', 'none', 'important');
    });
  }

  function cleanBlock(block) {
    // Sweep before choosing the panel, not after. Appstle injects display:none
    // clones of the whole price container (.appstle_subscription_final_price)
    // ahead of the theme's own, so querySelector below returned a clone and
    // every fix landed on a panel nobody could see - while the one the customer
    // actually reads kept the one-time price. A clone cannot strip itself from
    // inside, which is why sweeping the panel was never enough.
    block.querySelectorAll('*').forEach(function (el) {
      if (isAppstleJunk(el)) el.remove();
    });

    // The PDP wraps its price in .main-product-price. The sticky bar renders
    // price.liquid with no container class, so the block itself is the panel.
    var panel = block.querySelector('.main-product-price') || block;
    if (!panel) return;

    // Product cards already render the correct price in Liquid - including the
    // subscription price, via price.liquid's show_subscription_price. Strip what
    // Appstle injected on top, but never rewrite the amount.
    if (block.classList.contains('x-card-price')) {
      unstrikeCard(block);
      return;
    }

    // The PDP title price: the theme's variant price for a one-time purchase,
    // the subscription price with the one-time price struck beside it when a
    // plan is selected. Returns before the strikethrough sweep below, which
    // exists for the button and the sticky bar and would delete that struck
    // price. On a sale the theme renders .price-sale instead of p.price - left
    // alone, as it always has been, rather than rewriting a second markup.
    if (block.classList.contains('x-block-price')) {
      var titlePrice = panel.querySelector('p.price');
      if (!titlePrice) return;
      var oneTimeMoney = themeMoney(panel, block);
      var oneTimeCents = themeCents(panel);
      // Only the selling-plan JSON is trusted here. The button falls back to
      // scraping the amount out of Appstle's row, but a guess does not belong
      // under the product title, so a miss keeps the theme price instead.
      var planCents = selectedPlanCents(block);
      var onPlan = !isNaN(planCents);
      var discounted = onPlan && !isNaN(oneTimeCents) && planCents < oneTimeCents;
      flattenParagraph(
        titlePrice,
        onPlan ? formatMoney(planCents, moneyFormat(block)) : oneTimeMoney,
        discounted ? oneTimeMoney : ''
      );
      return;
    }

    // Subscription selected: show what is actually charged, not the theme's
    // one-time price. Falls back to the theme price for one-time purchases.
    var qty = blockQuantity(block);
    var planCents = selectedPlanCents(block);
    var money;
    if (!isNaN(planCents)) {
      money = formatMoney(planCents * qty, moneyFormat(block));
    } else {
      // selectedRowMoney() scrapes a formatted amount out of Appstle's row, so
      // there is no figure left to multiply - skip it once quantity matters and
      // let the theme's own cents carry the total.
      money = (qty === 1 ? selectedRowMoney(block) : '') || themeMoney(panel, block, qty);
    }
    if (!money) return;

    // The theme renders either <p class="price"> or, when on sale, a
    // <span class="price-sale"> next to <s class="price-compare">. Stripping
    // Appstle's injections can leave the struck compare price as the only thing
    // standing, which is why the button and sticky bar showed a crossed-out
    // amount and nothing else.
    var current = panel.querySelector('p.price') || panel.querySelector('.price-sale');
    if (current) {
      flattenParagraph(current, money);
    } else {
      var compare = panel.querySelector('s.price-compare, s, del');
      current = document.createElement('p');
      current.className = 'price';
      flattenParagraph(current, money);
      if (compare && compare.parentNode) compare.parentNode.insertBefore(current, compare);
      else panel.appendChild(current);
    }

    // Drop anything still rendered with a strikethrough. Checking the computed
    // style rather than the tag name matters: Appstle applies line-through via
    // CSS on plain spans, so removing <s>/<del> alone left the crossed-out
    // price on the add-to-cart button and the sticky bar.
    panel.style.setProperty('text-decoration', 'none', 'important');
    panel.querySelectorAll('*').forEach(function (el) {
      if (el === current || current.contains(el) || !el.isConnected) return;
      if (el.tagName === 'S' || el.tagName === 'DEL') {
        el.remove();
        return;
      }
      var decoration = '';
      try {
        decoration = window.getComputedStyle(el).textDecorationLine || '';
      } catch (e) {}
      if (decoration.indexOf('line-through') !== -1) el.remove();
    });
  }

  var scheduled = false;
  function refresh() {
    tagScopes();
    document
      .querySelectorAll(TAGGED_PRICE_BLOCK_SELECTOR)
      .forEach(cleanBlock);
    // Discard the records our own edits just queued, so the observer does not
    // call us straight back. Belt and braces with the idempotency above.
    var observer = document.body && document.body.__kalvePriceObserver;
    if (observer) observer.takeRecords();
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    setTimeout(function () {
      scheduled = false;
      refresh();
    }, 40);
  }

  function setupObservers() {
    if (document.body && !document.body.__kalvePriceObserver) {
      document.body.__kalvePriceObserver = new MutationObserver(schedule);
      document.body.__kalvePriceObserver.observe(document.body, { childList: true, subtree: true });
    }
    refresh();
  }

  setupObservers();
  document.addEventListener('DOMContentLoaded', setupObservers);
  window.addEventListener('load', setupObservers);
  [
    'AppstleSubscription:SubscriptionWidget:widgetInitialised',
    'AppstleSubscription:SubscriptionWidget:SubscriptionWidgetUpdated',
    'AppstleSubscription:SubscriptionWidget:SellingPlanSelected',
    'AppstleSubscription:SubscriptionWidget:SellingPlanDeSelected',
    'appstle_widget_updated'
  ].forEach(function (ev) {
    document.addEventListener(ev, schedule);
  });
  // Switching purchase option or variant changes the price but not the DOM,
  // so the MutationObserver above will not fire for it.
  document.addEventListener('change', function (event) {
    var target = event.target;
    if (!target) return;
    if (target.name === 'selling_plan' || target.name === 'id') schedule();
    else if (target.matches && target.matches('input.input-radio, select')) schedule();
  });

  // Quantity is the one input where schedule()'s 40ms timer is visible: the
  // theme's own updatePrice() writes qty x the ONE-TIME price into the button
  // synchronously on the stepper click, so the customer saw that total painted
  // first and the subscription total replace it a frame later.
  //
  // requestAnimationFrame rather than a straight call: the stepper buttons only
  // assign Alpine's qty, and x-model copies that into the input in a microtask,
  // so reading input.value from inside the click would still give the previous
  // quantity. rAF runs after Alpine has flushed and still before the frame is
  // painted, so the intermediate total never reaches the screen.
  //
  // focusout rather than blur: blur does not bubble, so a document listener for
  // it would have to capture, and capturing would put us back before the theme.
  function refreshAfterQuantity(event) {
    var target = event.target;
    if (!target || !target.closest) return;
    if (!target.closest('input[name="quantity"], [name="plus"], [name="minus"]')) return;
    if (window.requestAnimationFrame) window.requestAnimationFrame(refresh);
    else refresh();
  }
  ['click', 'input', 'change', 'focusout'].forEach(function (ev) {
    document.addEventListener(ev, refreshAfterQuantity);
  });
  [150, 500, 1200, 2500, 5000].forEach(function (ms) {
    setTimeout(setupObservers, ms);
  });

  // On reload Appstle restores the saved purchase option by assigning
  // radio.checked = true. That fires no change event and mutates nothing, so
  // neither the listeners nor the MutationObserver above see it, and the button
  // and sticky bar keep the one-time price. Watch the selection instead.
  var lastSelectionKey = null;
  var watcherTicks = 0;
  function selectionKey() {
    var parts = [];
    document
      .querySelectorAll('input[name="selling_plan"]:checked, select[name="selling_plan"], input[name="id"]')
      .forEach(function (el) {
        parts.push(el.value || '');
      });
    return parts.join('|');
  }
  setInterval(function () {
    var key = selectionKey();
    var changed = key !== lastSelectionKey;
    lastSelectionKey = key;
    // Re-assert unconditionally for the first ~10s. Appstle can finish
    // rendering, restore a plan, or overwrite the button price after our last
    // pass, and none of that necessarily changes the selection key.
    if (changed || watcherTicks < 25) schedule();
    watcherTicks++;
  }, 400);
})();

(function () {
  if (window.__kalveSizeSubscription) return;
  window.__kalveSizeSubscription = true;

  function normalizeSize(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/\s+/g, '')
      .replace(/×/g, 'x');
  }

  function is1kgValue(value) {
    var token = normalizeSize(value);
    if (!token || /x/.test(token)) return false;
    return token === '1kg' || token === '1kilos' || /^1kg/.test(token);
  }

  function is250gValue(value) {
    var token = normalizeSize(value);
    if (!token || /x/.test(token)) return false;
    return token === '250g' || /^250g/.test(token);
  }

  function isPackValue(value) {
    return /x/.test(normalizeSize(value));
  }

  function sizeFromText(value) {
    if (!value || isPackValue(value)) return '';
    if (is1kgValue(value)) return '1kg';
    if (is250gValue(value)) return '250g';
    return '';
  }

  function currentSize(root) {
    var wrap = root && root.getAttribute && root.hasAttribute('data-kalve-size-option')
      ? root
      : (root || document).querySelector('[data-kalve-size-option]');
    if (wrap) {
      var checked = wrap.querySelector('input:checked');
      if (checked) {
        var fromValue = sizeFromText(checked.value);
        if (fromValue) return fromValue;
        var label = wrap.querySelector('label[for="' + checked.id + '"]');
        if (label) {
          var fromLabel = sizeFromText(label.textContent);
          if (fromLabel) return fromLabel;
        }
      }
      var select = wrap.querySelector('select');
      if (select && select.value) {
        var fromSelect = sizeFromText(select.value);
        if (fromSelect) return fromSelect;
        var opt = select.options[select.selectedIndex];
        if (opt) {
          var fromOpt = sizeFromText(opt.text);
          if (fromOpt) return fromOpt;
        }
      }
    }

    var dataEl = document.querySelector('[data-selected-variant]');
    if (!dataEl) return '';
    try {
      var variant = JSON.parse(dataEl.textContent);
      var options = (variant && variant.options) || [];
      for (var i = 0; i < options.length; i++) {
        var size = sizeFromText(options[i]);
        if (size) return size;
      }
    } catch (e) {}
    return '';
  }

  function isVisible(el) {
    if (!el || el.hidden) return false;
    var style = window.getComputedStyle(el);
    if (!style || style.display === 'none' || style.visibility === 'hidden') return false;
    return el.offsetWidth > 0 || el.offsetHeight > 0 || el.getClientRects().length > 0;
  }

  function getHintScope(wrap) {
    var base = wrap || document.querySelector('[data-kalve-size-option]');
    if (!base) return document;
    return (
      base.closest('[id^="ProductInfo-"]') ||
      base.closest('.product-info') ||
      base.closest('[id^="shopify-section-"]') ||
      document
    );
  }

  function appstleWidget(scope) {
    var root = scope || document;
    var widgets = root.querySelectorAll(
      '[id^="appstle_subscription_widget"], .appstle_sub_widget, .appstle_subscription_wrapper'
    );
    for (var i = 0; i < widgets.length; i++) {
      if (isVisible(widgets[i])) return widgets[i];
    }
    return widgets[0] || null;
  }

  function frequencySelect(root) {
    var scope = root && root.querySelector ? root : getHintScope();
    var widget = appstleWidget(scope);
    if (!widget) widget = appstleWidget(document);
    if (!widget) return null;
    var selects = widget.querySelectorAll('select');
    var fallback = null;
    for (var i = 0; i < selects.length; i++) {
      if (!isVisible(selects[i])) continue;
      if (!fallback) fallback = selects[i];
      var text = '';
      for (var j = 0; j < selects[i].options.length; j++) {
        text += ' ' + selects[i].options[j].text;
      }
      if (/week|month|nedēļ|nädal|savait|mēnes|kuu|mėn/i.test(text)) return selects[i];
    }
    return fallback || selects[0] || null;
  }

  // Pre-selected delivery frequency per bag size, in weeks. Every variant shares
  // one selling plan group, so Appstle can only hold a single default for all of
  // them - which size is selected is something only the theme knows.
  var DEFAULT_FREQUENCY_WEEKS = { '250g': 1, '1kg': 3 };

  // The plans are labelled "Every 3 weeks" in English and "Ik 3 nedēļas" and
  // friends elsewhere, so match on the digit plus any week word rather than on
  // English phrasing. Same week tokens frequencySelect() uses.
  var WEEK_WORD = /week|nedēļ|nädal|savait/;

  function optionMatches(text, weeks) {
    var t = String(text || '').toLowerCase();
    if (!WEEK_WORD.test(t)) return 0;
    var digits = t.match(/\d+/);
    if (digits) return parseInt(digits[0], 10) === weeks ? 3 : 0;
    // "Every week" / "Weekly" carry no digit and mean every single week.
    return weeks === 1 ? 2 : 0;
  }

  // Appstle's class names differ per widget template, so styling them directly is
  // unreliable. Instead find the purchase-option rows structurally - every one
  // wraps an input[name="selling_plan"], which Shopify's cart API requires - and
  // tag them with our own classes for the CSS to target.
  function purchaseCards(scope) {
    var root = appstleWidget(scope) || scope || document;
    var inputs = [];
    root.querySelectorAll('input[name="selling_plan"]').forEach(function (input) {
      var form = input.closest('form');
      if (form) {
        var action = form.getAttribute('action') || '';
        if (action && action.indexOf('/cart/add') === -1) return;
      }
      inputs.push(input);
    });
    if (!inputs.length) return [];

    // Nearest element containing every radio: the rows are its children.
    var common = inputs[0].parentElement;
    for (var i = 1; i < inputs.length; i++) {
      while (common && !common.contains(inputs[i])) common = common.parentElement;
    }
    if (!common) return [];

    return inputs.map(function (input) {
      var card = input;
      while (card.parentElement && card.parentElement !== common) card = card.parentElement;
      if (card === input) card = input.closest('label') || input.parentElement;
      return { input: input, card: card };
    });
  }

  function tagPurchaseCards() {
    document.querySelectorAll('.kalve-sub-card, .kalve-onetime-card').forEach(function (el) {
      el.classList.remove('kalve-sub-card', 'kalve-onetime-card', 'kalve-card-selected');
    });
    purchaseCards(getHintScope()).forEach(function (entry) {
      var card = entry.card;
      if (!card || card === document.body || card === document.documentElement) return;
      card.classList.add(String(entry.input.value || '').trim() ? 'kalve-sub-card' : 'kalve-onetime-card');
      if (entry.input.checked) card.classList.add('kalve-card-selected');
    });
  }

  // Appstle rebuilds its widget from scratch on a variant change, because the
  // subscription price is per variant. The rebuilt rows are new elements without
  // our classes, while the checked plan, the consent and the row count all
  // survive - so buyStateKey() below cannot see that it happened. Everything
  // Appstle styles itself still looks right afterwards, which is why this only
  // ever showed as Subscribe & Save losing its background: .kalve-sub-card is
  // the one thing that paints it.
  function cardsNeedTagging() {
    var entries = purchaseCards(getHintScope());
    for (var i = 0; i < entries.length; i++) {
      var card = entries[i].card;
      if (!card || card === document.body || card === document.documentElement) continue;
      if (!card.classList.contains('kalve-sub-card') && !card.classList.contains('kalve-onetime-card')) {
        return true;
      }
    }
    return false;
  }

  var applyingFrequency = false;

  function selectFrequency(weeks) {
    var select = frequencySelect(getHintScope());
    if (!select || !select.options || !select.options.length) return;
    var best = null;
    var bestScore = 0;
    for (var i = 0; i < select.options.length; i++) {
      var score = optionMatches(select.options[i].text, weeks);
      if (score > bestScore) {
        bestScore = score;
        best = select.options[i];
      }
    }
    if (!best || select.value === best.value) return;
    // Flag our own dispatch so the change listener below does not mistake it
    // for the customer picking a frequency.
    applyingFrequency = true;
    select.value = best.value;
    select.dispatchEvent(new Event('input', { bubbles: true }));
    select.dispatchEvent(new Event('change', { bubbles: true }));
    applyingFrequency = false;
  }

  function isFrequencyControl(node) {
    if (!node || !node.closest) return false;
    if (node.tagName !== 'SELECT' && !node.classList.contains('appstle_subscription_dropdown')) return false;
    if (node.name === 'selling_plan') return false;
    return node === frequencySelect(getHintScope(node.closest('[data-kalve-size-option]')));
  }

  var lastSize = null;
  var userPickedFrequency = false;

  // An explicit ?selling_plan= in the URL is a deliberate choice - a deep link
  // or a restored selection - and must not be overwritten by the size default.
  function urlPinsPlan() {
    try {
      return !!new URLSearchParams(window.location.search).get('selling_plan');
    } catch (e) {
      return false;
    }
  }

  function syncFromSize() {
    if (urlPinsPlan()) return;
    var size = currentSize(document);
    if (!size) return;
    // Only pre-select a frequency when the size actually changes. Re-applying it
    // on every widget interaction is what made the dropdown snap back to 1 week.
    if (size === lastSize) return;
    lastSize = size;
    if (userPickedFrequency) return;
    var weeks = DEFAULT_FREQUENCY_WEEKS[size];
    if (weeks) selectFrequency(weeks);
  }

  // Same shape one level up: the subscriptions collection defaults the purchase
  // option the way bag size defaults the frequency. Appstle always renders
  // One-Time Purchase checked and rebuilds the rows during init, so a single
  // click at the wrong moment is lost - re-apply until it sticks.
  var applyingPlan = false;
  var userPickedPlan = false;
  var defaultPlanTicks = 0;

  // Queried by the attribute rather than through the element that carries it,
  // so moving the flag to another snippet stays a Liquid-only change.
  function defaultsToSubscription() {
    return !!document.querySelector('[data-kalve-default-subscription]');
  }

  function applyDefaultPlan() {
    // Budgeted rather than run forever: this covers the 200/800/2000ms re-runs
    // and the widget's event bursts, after which Appstle has settled and a flip
    // would read as the page changing its mind rather than as a default.
    if (userPickedPlan || defaultPlanTicks > 20) return;
    // An explicit ?selling_plan= is a deliberate choice, same as for frequency.
    if (!defaultsToSubscription() || urlPinsPlan()) return;
    defaultPlanTicks++;

    var entries = purchaseCards(getHintScope());
    var sub = null;
    for (var i = 0; i < entries.length; i++) {
      var input = entries[i].input;
      // Empty value is the one-time row; a plan id is the one we want.
      if (!String(input.value || '').trim()) continue;
      if (input.checked) return;
      if (!sub) sub = input;
    }
    if (!sub) return;
    // click(), not checked = true: Appstle reprices and re-renders off the
    // event, and assigning the property fires nothing.
    applyingPlan = true;
    sub.click();
    applyingPlan = false;
  }

  // --- Consent gate + buy-button labels -------------------------------------
  // The consent checkbox blocks SUBSCRIPTION purchases only. One-time purchases
  // are never blocked, which is why this keys off the checked selling_plan
  // rather than off the widget being present.

  function termsBlock() {
    return document.querySelector('[data-kalve-terms]');
  }

  function termsAgreed() {
    var box = document.querySelector('[data-kalve-terms-input]');
    return !box || box.checked;
  }

  function subscriptionSelected() {
    var entries = purchaseCards(getHintScope());
    for (var i = 0; i < entries.length; i++) {
      if (entries[i].input.checked) return !!String(entries[i].input.value || '').trim();
    }
    return false;
  }

  // The buy button used to be looked up inside the first non-sticky
  // form[id^="product-form-"], which found nothing: the variant_picker block
  // opens its own <form> carrying the same id as the buy_buttons one and, with
  // the picker above the buttons, that empty duplicate came first in the DOM.
  // A null button meant the consent gate silently never reached Add to cart -
  // only Subscribe, which is looked up document-wide, ever greyed out. Resolve
  // the button directly instead, and let form association rather than
  // containment rule out the sticky bar.
  function mainAtcButton() {
    var scope = getHintScope();
    var buttons = (scope || document).querySelectorAll('.add_to_cart_button');
    if (!buttons.length) buttons = document.querySelectorAll('.add_to_cart_button');
    var fallback = null;
    for (var i = 0; i < buttons.length; i++) {
      var btn = buttons[i];
      // getAttribute, not .id: the form holds <input name="id">, and a form
      // exposes its controls as named properties, so .id is that input element.
      var form = btn.form || btn.closest('form');
      if (((form && form.getAttribute('id')) || '').indexOf('product-form-sticky-') === 0) continue;
      if (!fallback) fallback = btn;
      // Quick view server-renders a full hidden form for the current product on
      // PDPs, so prefer the button a customer can actually reach.
      if (isVisible(btn)) return btn;
    }
    return fallback;
  }

  function firstTextNode(el) {
    for (var i = 0; i < el.childNodes.length; i++) {
      var n = el.childNodes[i];
      if (n.nodeType === 3 && String(n.nodeValue).trim()) return n;
    }
    return null;
  }

  // "Add to cart - <price>" becomes "Add subscription <price> to cart", so the
  // leading text node is rewritten, the theme's " - " separator is hidden and a
  // trailing node is appended after the price element.
  function setAtcLabel(atc, subscribed, block) {
    var label = atc.querySelector('.x-atc-text');
    if (!label) return;
    var node = firstTextNode(label);
    if (!node) return;
    if (!label.hasAttribute('data-kalve-label-original')) {
      label.setAttribute('data-kalve-label-original', node.nodeValue);
    }
    var price = label.querySelector('.main-product-price');
    var sep = price ? price.previousElementSibling : null;
    var suffix = label.querySelector('[data-kalve-atc-suffix]');

    if (subscribed && block) {
      node.nodeValue = block.getAttribute('data-kalve-add-subscription-label') + ' ';
      if (sep) sep.style.display = 'none';
      if (!suffix) {
        suffix = document.createElement('span');
        suffix.setAttribute('data-kalve-atc-suffix', '');
        label.appendChild(suffix);
      }
      suffix.textContent = ' ' + block.getAttribute('data-kalve-add-subscription-suffix');
      return;
    }
    node.nodeValue = label.getAttribute('data-kalve-label-original');
    if (sep) sep.style.display = '';
    if (suffix) suffix.remove();
  }

  function setPrimaryLabel(btn, subscribed, block) {
    var label = btn.querySelector('.x-atc-text');
    if (!label) return;
    if (!label.hasAttribute('data-kalve-label-original')) {
      label.setAttribute('data-kalve-label-original', label.textContent.trim());
    }
    label.textContent =
      subscribed && block
        ? block.getAttribute('data-kalve-subscribe-label')
        : label.getAttribute('data-kalve-label-original');
  }

  // Only ever re-enable a button this code disabled - the theme disables the
  // same buttons for sold out, quantity rules and unselected variants.
  function toggleBlocked(btn, blocked) {
    if (blocked) {
      if (!btn.disabled) {
        btn.disabled = true;
        btn.setAttribute('data-kalve-blocked', '');
      }
      return;
    }
    if (btn.hasAttribute('data-kalve-blocked')) {
      btn.disabled = false;
      btn.removeAttribute('data-kalve-blocked');
    }
  }

  // Liquid renders the consent row before Appstle injects its widget, so in the
  // DOM it lands above Purchase Options. Move it back under the widget once the
  // widget exists.
  function placeTermsBlock(block) {
    if (!block) return;
    // Directly under the purchase-option cards. Anchor on the card stack rather
    // than the widget root or the buy row. The widget is injected inside
    // .product-form__buy-row, which is a flex row, so the block also carries
    // flex-basis:100% in CSS to claim its own line rather than sitting beside
    // the quantity stepper.
    var stack =
      document.querySelector('.appstle_subscription_wrapper') ||
      document.querySelector('.product-form__buy-row');
    if (!stack || !stack.parentElement || stack.contains(block)) return;
    if (stack.nextElementSibling === block) return;
    stack.parentElement.insertBefore(block, stack.nextSibling);
  }

  // Appstle renders its own indicator (.appstle_circle > .appstle_dot) and, on
  // the active row, at least one more. Stylesheet rules kept losing to its own
  // CSS, so hide every indicator it draws and paint a single one of our own
  // with inline styles, which nothing in a stylesheet can outrank.
  function paintRadios() {
    purchaseCards(getHintScope()).forEach(function (entry) {
      var label = entry.card.querySelector('.appstle_radio_label');
      if (!label) return;

      label.querySelectorAll('.appstle_circle, .appstle_dot').forEach(function (el) {
        if (el.classList.contains('kalve-radio')) return;
        el.style.setProperty('display', 'none', 'important');
      });

      var dot = label.querySelector('.kalve-radio');
      if (!dot) {
        dot = document.createElement('span');
        dot.className = 'kalve-radio';
        dot.setAttribute('aria-hidden', 'true');
        label.insertBefore(dot, label.firstChild);
      }

      // Every property carries !important: the blanket reset earlier in
      // appstle-widget.css strips border and background from all descendants
      // with !important, and a plain inline style loses to that.
      var on = !!entry.input.checked;
      dot.style.cssText =
        'box-sizing:border-box !important;' +
        'display:inline-block !important;' +
        'flex:0 0 auto !important;' +
        'width:16px !important;height:16px !important;' +
        'margin-right:12px !important;' +
        'border-radius:50% !important;' +
        'border:2px solid ' + (on ? '#302D2F' : '#D6D6D6') + ' !important;' +
        'background:' +
        (on
          ? 'radial-gradient(circle at center, #302D2F 0 4px, transparent 4px)'
          : 'transparent') +
        ' !important;';
    });
  }

  function updateBuyControls() {
    var block = termsBlock();
    paintRadios();
    var hasPlans = purchaseCards(getHintScope()).length > 0;
    var subscribed = subscriptionSelected();
    // Consent is a subscription requirement only, so the row is hidden for
    // one-time purchases. Its checked state is left alone, so switching back to
    // Subscribe & Save restores whatever the customer already ticked.
    if (block) block.hidden = !hasPlans || !subscribed;
    placeTermsBlock(block);

    var blocked = subscribed && !termsAgreed();

    var atc = mainAtcButton();
    if (atc) {
      setAtcLabel(atc, subscribed, block);
      toggleBlocked(atc, blocked);
    }
    var buyNow = document.querySelector('[id^="custom-buy-now-"]');
    if (buyNow) {
      setPrimaryLabel(buyNow, subscribed, block);
      toggleBlocked(buyNow, blocked);
    }
  }

  document.addEventListener('change', function (event) {
    if (event.target && event.target.closest && event.target.closest('[data-kalve-terms-input]')) {
      updateBuyControls();
    }
  });

  // The link sits inside the <label>, so a click would otherwise toggle the box.
  document.addEventListener('click', function (event) {
    if (event.target && event.target.closest && event.target.closest('[data-kalve-terms-link]')) {
      event.stopPropagation();
    }
  });

  // Cheap fingerprint of everything the buy controls depend on: which plan is
  // checked, whether consent is given, and how many option rows exist.
  var lastBuyStateKey = null;
  function buyStateKey() {
    var parts = [];
    document.querySelectorAll('input[name="selling_plan"]').forEach(function (input) {
      if (input.checked) parts.push(String(input.value || 'one-time'));
    });
    var box = document.querySelector('[data-kalve-terms-input]');
    parts.push(box && box.checked ? 'agreed' : 'not-agreed');
    parts.push(String(document.querySelectorAll('input[name="selling_plan"]').length));
    return parts.join('|');
  }

  var scheduled = false;
  function schedule(force) {
    if (scheduled && !force) return;
    scheduled = true;
    setTimeout(function () {
      scheduled = false;
      // These three rewrite classes and labels on the purchase options, which
      // is layout-thrashing work. The widget fires its events in bursts, so do
      // it only when something a human changed actually differs.
      // A fresh set of rows is work that has to be redone even when the state
      // fingerprint is identical, so check the DOM itself too. This settles in
      // one pass: after tagging, cardsNeedTagging() is false again, and the
      // observer watches childList only, so our own class writes never re-arm it.
      var key = buyStateKey();
      if (key !== lastBuyStateKey || cardsNeedTagging()) {
        lastBuyStateKey = key;
        tagPurchaseCards();
        updateBuyControls();
      }
      syncFromSize();
      applyDefaultPlan();
    }, 60);
  }

  function onAppstleEvent() {
    schedule(true);
  }

  [
    'AppstleSubscription:SubscriptionWidget:widgetInitialised',
    'AppstleSubscription:SubscriptionWidget:SubscriptionWidgetUpdated',
    'AppstleSubscription:SubscriptionWidget:SellingPlanSelected',
    'AppstleSubscription:SubscriptionWidget:SellingPlanDeSelected',
    'AppstleSubscription:SubscriptionWidget:SellingPlanRemoved',
    'AppstleSubscription:SubscriptionWidget:sellingPlanChanged',
    'AppstleSubscription:SubscriptionWidget:SwitchedToSubscription',
    'AppstleSubscription:SubscriptionWidget:SwitchedToOneTime',
    'appstle_widget_updated'
  ].forEach(function (ev) {
    document.addEventListener(ev, onAppstleEvent);
    window.addEventListener(ev, onAppstleEvent);
  });

  document.addEventListener(
    'click',
    function (event) {
      if (!event.target || !event.target.closest) return;
      if (event.target.closest('[class*="appstle"], [id^="appstle"]')) schedule(true);
    },
    true
  );

  document.addEventListener('change', function (event) {
    if (!event.target) return;
    // A frequency the customer chose themselves is never overwritten again.
    if (!applyingFrequency && isFrequencyControl(event.target)) {
      userPickedFrequency = true;
    }
    // Likewise for the purchase option: once the customer has chosen one, the
    // collection default must never flip it back under them.
    if (!applyingPlan && event.target.name === 'selling_plan') {
      userPickedPlan = true;
    }
    if (
      event.target.closest('[data-kalve-size-option]') ||
      event.target.closest('[id^="appstle_subscription_widget"], .appstle_sub_widget, .appstle_subscription_wrapper, [class*="appstle"]') ||
      event.target.matches('input.input-radio, input[name="selling_plan"], select[name="selling_plan"]')
    ) {
      schedule(true);
    }
  });

  if (document.body) {
    var observer = new MutationObserver(function () {
      schedule(false);
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  // These re-runs exist to catch Appstle initialising late. They must not reset
  // lastSize - doing so re-applied the size default up to 2s after load and
  // overwrote a frequency the customer had already picked.
  document.addEventListener('DOMContentLoaded', function () {
    schedule(true);
  });
  window.addEventListener('load', function () {
    schedule(true);
  });
  [200, 800, 2000].forEach(function (ms) {
    setTimeout(function () {
      schedule(true);
    }, ms);
  });
})();
